// src/components/Assessment/Assessment.jsx
import React from "react";
import Header from "../../components/Header/Header";
import styles from "./Assessment.module.css";
import AssessmentEditor from "./AssessmentEditor";
import SideBar from "../../components/SideBar/AdminSideBar";

const EditLevel = () => {

  return (
    <>
      <div className="main-wrapper">
        <Header />
        <SideBar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className={styles.assessmentContainer}>
              <h1 className={styles.title}>Assessment Dashboard</h1>
          
              <div className={styles.section}>
                <AssessmentEditor />
              </div>
  

              {/* <div className={styles.section}>
                <QuizCreator addQuiz={addQuiz} />
              </div>
              <div className={styles.section}>
                <QuizList
                  quizzes={quizzes}
                  selectQuiz={selectQuiz}
                  userMarks={userMarks}
                />
              </div>
              {currentQuiz && (
                <div className={styles.section}>
                  <QuizTaker quiz={currentQuiz} saveMarks={saveMarks} />
                </div>
              )} */}
              {/* <SideBar />
 */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditLevel;
